// Device detection utility
// Detects iOS devices (iPhone, iPad, iPod) for feature gating

export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
